import React from 'react';
import PropTypes from 'prop-types';
import logoSrc from 'assets/full_leal_logo_dark.svg';
import noTitleLogoSrc from 'assets/logo_no_title.svg';
import styles from './hcpPageHeaderView.module.css';
import { MenuItems } from './MenuItems';

export const HCPPageHeaderView = ({
  headerRightSlot,
  isLogoShown = true,
  onLogoClick,
  tabIds,
  onMobileMenuItemClick,
  activeTab,
}) => (
  <header className={styles.root}>
    {isLogoShown && (
      <>
        <img
          className={styles.logo}
          src={logoSrc}
          alt="Leal Health Logo"
          onClick={onLogoClick}
        />
        <img
          className={styles.logoNoTitle}
          src={noTitleLogoSrc}
          alt="Leal Health Logo"
          onClick={onLogoClick}
        />
      </>
    )}
    {!!tabIds.length && (
      <MenuItems
        tabIds={tabIds}
        onMenuItemClick={onMobileMenuItemClick}
        activeItem={activeTab}
      />
    )}
    {headerRightSlot}
  </header>
);

HCPPageHeaderView.propTypes = {
  tabIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeTab: PropTypes.string,
  isLogoShown: PropTypes.bool,
  onLogoClick: PropTypes.func,
  headerRightSlot: PropTypes.node,
  onMobileMenuItemClick: PropTypes.func.isRequired,
};
